import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// @mui material components
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import ImageUpload from "components/CustomUpload/ImageUpload";

import {
	REMOVE_ORGANIZATION_IMAGE,
	SET_ORGANIZATION_FILES_IMAGES,
	SET_ORGANIZATION_NAME,
	SET_ORGANIZATION_NAME_ERROR,
	ADD_ORGANIZATION_CHANNEL,
	DELETE_ORGANIZATION_CHANNEL,
	REORDER_ORGANIZATION_CHANNELS,
	SET_ORGANIZATION_CUSTOM_URI,
	SET_ORGANIZATION_CUSTOM_URI_ERROR,
	SET_ORGANIZATION_VISIBLE
} from "actions/types";
import { fetchSearchOrganizationChannels } from "actions/channel";
// import { fetchSearchOrganizationCityChannels } from "actions/channel";

import SortableTags from "components/DigiHapi/SortableTags";

class Step1 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		const { dispatch, name, customUri } = this.props;

		let success = true;
		if (!name || name.trim().length === 0) {
			dispatch({
				type: SET_ORGANIZATION_NAME_ERROR
			});
			success = false;
		}
		if (!customUri || customUri.trim().length === 0) {
			dispatch({
				type: SET_ORGANIZATION_CUSTOM_URI_ERROR
			});
			success = false;
		}
		return success;
	}

	onImageLoaded = (name, imagePreviewUrl) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_ORGANIZATION_FILES_IMAGES,
			payload: [{ name, base64: imagePreviewUrl, out: "logoUri" }]
		});
	};

	onImageRemoved = () => {
		this.props.dispatch({
			type: REMOVE_ORGANIZATION_IMAGE
		});
	};

	// onOrganizationMapLoaded = (name, imagePreviewUrl) => {
	// 	const { dispatch } = this.props;
	// 	dispatch({
	// 		type: SET_ORGANIZATIONMAP_FILES_IMAGES,
	// 		payload: [
	// 			{
	// 				name,
	// 				base64: imagePreviewUrl,
	// 				ignoreQualityTransform: true,
	// 				out: "mapUri"
	// 			},
	// 			{ name: name + "-small", base64: imagePreviewUrl, out: "mapSmallUri" }
	// 		]
	// 	});
	// };

	// onOrganizationMapRemoved = () => {
	// 	this.props.dispatch({
	// 		type: REMOVE_ORGANIZATIONMAP_IMAGE
	// 	});
	// };

	handleDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_ORGANIZATION_CHANNEL,
				index
			});
		}
	};

	handleReorder = (from, to) => {
		this.props.dispatch({
			type: REORDER_ORGANIZATION_CHANNELS,
			from,
			to
		});
	};

	handleAddition = channel => {
		this.props.dispatch({
			type: ADD_ORGANIZATION_CHANNEL,
			value: channel
		});
	};

	handleToggleVisible = () => {
		this.props.dispatch({
			type: SET_ORGANIZATION_VISIBLE,
			value: !this.props.isVisible
		});
	};

	onInput = query => {
		if (query?.length > 2) {
			this.props.fetchSearchOrganizationChannels(
				query,
				this.props._id,
				this.props.ignoreWeather
			);
		}
	};

	render() {
		const {
			dispatch,
			name,
			nameErrorMsg,
			customUri,
			customUriErrorMsg,
			logoUri,
			channels,
			channelsSuggestions,
			isVisible
		} = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12} sm={4}>
					<MDTypography component="div" variant="h6" mb={1}>
						Logo
					</MDTypography>
					<ImageUpload
						onImageLoaded={this.onImageLoaded}
						onImageRemoved={this.onImageRemoved}
						photoUri={logoUri}
					/>
				</Grid>
				<Grid item xs={12} sm={8}>
					<FormControlLabel
						control={
							<Checkbox
								checked={!!isVisible}
								onChange={this.handleToggleVisible}
							/>
						}
						label="Visible dans l'application"
					/>
					<FormHelperText>
						{
							"Une organisation invisible n'est plus proposée dans les listes et recherches de l'application"
						}
					</FormHelperText>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Nom *"
						id="name"
						fullWidth
						error={!!nameErrorMsg}
						helperText={nameErrorMsg}
						value={name ? name : ""}
						onChange={e =>
							dispatch({
								type: SET_ORGANIZATION_NAME,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="URI *"
						id="uri"
						fullWidth
						error={!!customUriErrorMsg}
						helperText={customUriErrorMsg}
						value={customUri ? customUri : ""}
						onChange={e =>
							dispatch({
								type: SET_ORGANIZATION_CUSTOM_URI,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDBox width="100%">
						<FormHelperText>
							{
								"Canaux de diffusion depuis lesquelles recevoir publications, bons plans et météo"
							}
						</FormHelperText>
						<SortableTags
							placeholderText="Canaux de diffusion ..."
							tags={channels}
							suggestions={channelsSuggestions}
							minQueryLength={3}
							maxSuggestionsLength={10}
							onDelete={this.handleDelete}
							onAddition={this.handleAddition}
							onReorder={this.handleReorder}
							suggestionsFilter={() => true}
							onInput={this.onInput}
							removeButtonText="Cliquez pour retirer"
							inputAttributes={{
								autoComplete: "whatever"
							}}
						/>
					</MDBox>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		_id,
		name,
		nameErrorMsg,
		logoUri,
		mapSmallUri,
		registerkey,
		channels,
		channelsSuggestions,
		customUri,
		customUriErrorMsg,
		stars,
		ignoreWeather,
		isVisible
	} = state.organizationReducer;
	return {
		_id,
		name,
		nameErrorMsg,
		logoUri,
		mapSmallUri,
		registerkey,
		channels: Object.values(channels),
		channelsSuggestions: Object.values(channelsSuggestions),
		customUri,
		customUriErrorMsg,
		stars,
		ignoreWeather,
		isVisible
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			// fetchSearchOrganizationCityChannels
			fetchSearchOrganizationChannels
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step1);
